import { createContext } from 'react'
import { DomainDto } from '../../../dtos/domain'
import { Journey } from '../../../features/journeys/types/journey-api-response'
import { JourneyBuilderMode } from '../enums'
import { JourneyEditableState } from '@pushly/models/lib/enums/journeys'
import { SegmentDto } from '../../../dtos/segment'
import { IConfigurationFlags } from './interfaces'

interface IConfigurationContext {
    mode: JourneyBuilderMode
    loading: boolean
    domain: DomainDto
    domainDefaultSegment?: SegmentDto
    journey: Journey
    setJourney: (changes: Journey, debounce?: boolean) => void
    editableState: JourneyEditableState
    flags: IConfigurationFlags
    setFlags: (flags: Partial<IConfigurationFlags>) => void
}

export const ConfigurationContext = createContext<IConfigurationContext>({} as IConfigurationContext)
